import { Module } from 'vuex'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { RootState } from '@/store/types'
import { RecipesState } from './types'

export const state: RecipesState = {
  fetched: false,
  current: {} as any,
  widgets: [],
}

const namespaced = true

export const recipes: Module<RecipesState, RootState> = {
  namespaced,
  mutations,
  actions,
  getters,
  state,
}
